import React, { Component } from 'react'
import { TouchableOpacity, Clipboard } from 'react-native'
import { connect } from 'react-redux'
import _ from 'lodash'

import { getSelectedStore } from 'x/redux/selectors'

import {
  ISelectedStoreMap,
  IOrderProductBundleDetailViewNavParams,
  IXScreenProps,
  IOrderProductItem,
  IBundleOrderProductVariant,
} from 'x/types'
import * as util from 'x/utils/util'
import * as xFmt from 'x/utils/formatter'
// import HelpButton from 'xui/components/HelpButton'
import p from 'x/config/platform-specific'
import * as NavActions from 'x/utils/navigation'

import VStack from 'xui/components/VStack'
import XText from 'xui/components/XText'
import HStack from 'xui/components/HStack'
import XIcon from 'xui/components/XIcon'
import XOverlay from 'xui/components/XOverlay'
import XCustomHeader from 'xui/components/XCustomHeader'
import XContent from 'xui/components/XContent'
import ForwardIcon from 'xui/components/ForwardIcon'
import XButton from 'xui/components/XButton'
import XContainer from 'xui/components/XContainer'
import XImage from 'xui/components/XImage'
import XCard from 'xui/components/XCard'
import { COLORS } from 'x/config/styles'
import XSpinner from 'xui/components/XSpinner'
import ProductBundleContainer from 'xui/components/ProductBundleContainer'

interface IOrderProductBundleDetailViewProps extends IXScreenProps<IOrderProductBundleDetailViewNavParams> {
  selectedStore?: ISelectedStoreMap

  // onPick?: (warehouse: IWarehousesDetail) => void
  // title?: string
}

interface IOrderProductBundleDetailViewState {
  isInitialized: boolean

  showProfit: boolean
  product: IOrderProductItem
}

export class OrderProductBundleDetailView extends Component<IOrderProductBundleDetailViewProps, IOrderProductBundleDetailViewState> {
  static displayName = 'OrderProductBundleDetailView'

  inProcess?: boolean

  constructor(props) {
    super(props)
    this.state = {
      isInitialized: false,
      showProfit: false,
      product: null,
    }
  }

  async componentDidMount() {
    await this._initialize()

    await util.setStatePromise(this, { isInitialized: true })
  }

  _goBack = () => {
    util.navGoBack(this.props)
  }

  _initialize = async () => {
    // @ts-ignore
    // const params = util.getNavParams(this.props)
    // const { product, showProfit, productBundles } = params
    const product = util.getNavParam(this.props, 'product')
    const showProfit = util.getNavParam(this.props, 'showProfit', false)

    // console.log('_initialize product => ', product)
    this.setState({ showProfit, product })
  }

  _renderCustomHeader = () => {
    const titleHeader = 'รายละเอียดสินค้าเซต'

    return (
      <XCustomHeader
        title={titleHeader}
        headerLeftProps={{
          backIcon: true,
          onPressItem: () => this._goBack(),
        }}
      />
    )
  }

  _renderTitleDescription = () => {
    const { product, showProfit } = this.state
    // console.log('product => ', product)
    if (_.isNil(product)) {
      return null
    }

    const price_after_discount = product.price_after_discount || '0'
    const cost = product.cost || '0'
    // const profit = +price_after_discount - +cost
    const profit = parseFloat(price_after_discount) - parseFloat(cost)
    const price = product.price || '0'
    const isPriceEqual = price && price_after_discount && price === price_after_discount

    // const priceRender =
    //   price === price_after_discount ? (
    //     <XText bold>{xFmt.formatCurrency(price)}</XText>
    //   ) : (
    //     <HStack>
    //       <XText textDecorationLine='line-through' variant='inactive'>
    //         {xFmt.formatCurrency(price)}
    //       </XText>
    //       <XText ml='2' bold>
    //         {xFmt.formatCurrency(price_after_discount)}
    //       </XText>
    //     </HStack>
    //   )

    return (
      <VStack w='full' p='2' bg='white'>
        <ProductBundleContainer productBundleItem={product}>
          <VStack
            w='full'
            // h={showProfit ? '130px' : '110px'}
            p='2'
            // bgColor={COLORS.BLUE_TAB}
          >
            <HStack w='full'>
              <XImage source={{ uri: product.thumbnail_uris[0] }} alt='image' w='60px' h='60px' borderRadius='md' resizeMode='cover' />
              <VStack ml='2' flex={1}>
                <XText numberOfLines={1} variant='inactive' fontSize='xs'>
                  {product.name}
                </XText>
                <XText numberOfLines={1} variant='active' bold>
                  {`${product.variant}`}
                </XText>
                {/* <XText numberOfLines={1} variant='active' fontSize='xs' bold>
                  {`${xFmt.formatCurrency(product.price)}`}
                </XText> */}
                {isPriceEqual ? (
                  <XText bold>{`ราคาต่อหน่วย: ${xFmt.formatCurrency(price)}`}</XText>
                ) : (
                  <HStack>
                    <XText>{'ราคาต่อหน่วย: '}</XText>
                    <XText textDecorationLine='line-through' variant='inactive'>
                      {xFmt.formatCurrency(price)}
                    </XText>
                    <XText ml='2' bold>
                      {xFmt.formatCurrency(price_after_discount)}
                    </XText>
                  </HStack>
                )}

                {showProfit ? (
                  <XText numberOfLines={1} variant='inactive' color={COLORS.BRAND_Success}>
                    {`กำไรต่อหน่วย: ${xFmt.formatCurrency(profit)}`}
                  </XText>
                ) : null}

                {product.sku && product.sku !== '' ? (
                  <XText numberOfLines={1} fontSize='xs' variant='inactive'>
                    {`SKU: ${product.sku}`}
                  </XText>
                ) : null}
                {product.sku && product.sku !== '' ? (
                  <XText numberOfLines={1} fontSize='xs' variant='inactive'>
                    {`UPC: ${product.upc}`}
                  </XText>
                ) : null}
              </VStack>
              <VStack w='16' flexDirection='flex-end' alignItems='flex-end'>
                <XText fontSize='2xl' bold>{`x ${product.qty}`}</XText>
              </VStack>
            </HStack>

            <HStack w='full' alignItems='center' space='1'>
              <XText
                fontSize='xs'
                variant='inactive'
                onPress={() => this._handlePressProductID(product.pp_id)}
              >{`ID:${product.pp_id}`}</XText>
            </HStack>
          </VStack>
        </ProductBundleContainer>
      </VStack>
    )
  }

  _navToVariantStockListView = (ppId: number) => {
    const { navigation } = this.props
    const storeId = util.getNavParam(this.props, 'store_id')

    navigation.dispatch(
      NavActions.navToSearchProductVariantListView({
        store_id: storeId,
        pp_ids: [ppId],
        isNavToProductDetailDisabled: true,
        isBundleOperationsDisabled: true,
      })
    )
  }

  _navToProductDetail = (productId: number) => {
    if (this.inProcess) {
      return
    }
    this.inProcess = true

    const { navigation } = this.props
    const storeId = util.getNavParam(this.props, 'store_id')

    navigation.dispatch(
      NavActions.navToProductViewMyStore({
        store_id: storeId,
        product_id: productId,
      })
    )

    this.inProcess = false
  }

  // _renderProductBundles = (productBundle: IOrderProductItem, index: number) => {
  _renderProductBundles = (productBundle: IBundleOrderProductVariant, index: number) => {
    const isNavToProductDetailDisabled = util.getNavParam(this.props, 'isNavToProductDetailDisabled', false)
    const { showProfit, product } = this.state
    const name = productBundle.name || ''
    const imgs = productBundle.thumbnail_uris || []
    const price = productBundle.price || '0'

    const price_after_discount = productBundle.price_after_discount || '0'
    const cost = productBundle.cost || '0'
    const profit = +price_after_discount - +cost
    const ppId = productBundle.pp_id

    const priceRender =
      price === price_after_discount ? (
        <XText bold>{`ราคาต่อหน่วย: ${xFmt.formatCurrency(price)}`}</XText>
      ) : (
        <HStack>
          <XText>{'ราคาต่อหน่วย: '}</XText>
          <XText textDecorationLine='line-through' variant='inactive'>
            {xFmt.formatCurrency(price)}
          </XText>
          <XText ml='2' bold>
            {xFmt.formatCurrency(price_after_discount)}
          </XText>
        </HStack>
      )
    return (
      <XCard key={`pb-item-${index}`} p='2'>
        <HStack w='full' space='1'>
          <XImage source={{ uri: imgs[0] }} alt='image' w='50px' h='50px' borderRadius='md' resizeMode='cover' />
          <VStack ml='2' flex={1}>
            <XText numberOfLines={1} variant='inactive' fontSize='xs'>
              {name}
            </XText>
            <XText numberOfLines={1} variant='active' bold>
              {productBundle.variant}
            </XText>
            {priceRender}

            {showProfit ? (
              <XText numberOfLines={1} variant='inactive' color={COLORS.BRAND_Success}>
                {`กำไรต่อหน่วย: ${xFmt.formatCurrency(profit)}`}
              </XText>
            ) : null}

            {productBundle.sku && productBundle.sku !== '' ? (
              <XText numberOfLines={1} fontSize='xs' variant='inactive'>
                {`SKU: ${productBundle.sku}`}
              </XText>
            ) : null}
            {productBundle.upc && productBundle.upc !== '' ? (
              <XText numberOfLines={1} fontSize='xs' variant='inactive'>
                {`UPC: ${productBundle.upc}`}
              </XText>
            ) : null}
          </VStack>
          <VStack w='100px' flexDirection='flex-end' alignItems='flex-end' space='1'>
            <HStack w='full' alignContent='center' justifyContent='flex-end' space='1.5'>
              {product.product_id && !isNavToProductDetailDisabled ? (
                <XText fontSize='xs' color='blue.500' underline onPress={() => this._navToProductDetail(product.product_id)}>
                  ดูสินค้า
                </XText>
              ) : null}

              <XText fontSize='xs' color='blue.500' underline onPress={() => this._navToVariantStockListView(ppId)}>
                ดูสต๊อก
              </XText>
            </HStack>

            <XText fontSize='lg' bold>{`x ${productBundle.qty}`}</XText>

            {/* {product.product_id && !isNavToProductDetailDisabled ? (
              <TouchableOpacity onPress={() => this._navToProductDetail(product.product_id)}>
                <VStack pl='2' alignItems='center'>
                  <XIcon name='information-circle-outline' />
                  <XText variant='primary' fontSize='3xs'>
                    ดูสินค้า
                  </XText>
                </VStack>
              </TouchableOpacity>
            ) : null} */}
          </VStack>
        </HStack>

        <HStack w='full' alignItems='center' space='1'>
          <XText fontSize='xs' variant='inactive'>{`#${index + 1}`}</XText>
          <XText
            fontSize='xs'
            variant='inactive'
            onPress={() => this._handlePressProductID(productBundle.pp_id)}
          >{`ID:${productBundle.pp_id}`}</XText>
        </HStack>
      </XCard>
    )
  }

  _handlePressProductID = (id: number) => {
    try {
      Clipboard.setString(id.toString())
      p.op.showToast(`คัดลอก ${id} ไปยังคลิปบอร์ดแล้ว`, 'success')
    } catch (error) {
      console.log('_handlePressProductID error => ', error)
    }
  }

  _renderMappings = () => {
    const { product } = this.state
    // console.log('productBundles => ', productBundles)
    if (_.isNil(product) || !('bundle_product_mappings' in product)) {
      return null
    }

    return (
      <VStack w='full' bgColor={COLORS.WHITE} px='2' pb='2' space='1.5'>
        {product.bundle_product_mappings.map(this._renderProductBundles)}
      </VStack>
    )
  }

  _renderCountQty = () => {
    const { product } = this.state
    if (_.isNil(product) || !('bundle_product_mappings' in product)) {
      return null
    }
    const productLength = product.bundle_product_mappings.length
    const qtyTotal = _.sumBy(product.bundle_product_mappings, 'qty')
    return (
      <HStack bgColor={COLORS.WHITE} pt={'4'} pl='2'>
        <XText bold variant='inactive'>{`รายการสินค้าในเซต (สินค้า: ${productLength}, จำนวน: ${qtyTotal})`}</XText>
      </HStack>
    )
  }

  _renderContent = () => {
    const { isInitialized } = this.state
    if (!isInitialized) {
      return (
        <VStack w='full' h='200px' justifyContent='center' alignItems='center'>
          <XSpinner />
        </VStack>
      )
    }

    return (
      <XContent>
        {this._renderTitleDescription()}
        {this._renderCountQty()}
        {this._renderMappings()}
      </XContent>
    )
  }

  render() {
    return (
      <XContainer>
        {this._renderCustomHeader()}

        {this._renderContent()}
      </XContainer>
    )
  }
}

export default connect(
  (state) => ({
    selectedStore: getSelectedStore(state),
  }),
  (dispatch) => ({
    dispatch,
  })
)(OrderProductBundleDetailView)
